import { createChunk } from '../Chunks';
import { createChunksMatcher } from '../createChunksMatcher';
export function withTitle(maybeResolvableTitle, child) {
  return createChunksMatcher(maybeResolvableTitle, child, function (title, request) {
    return title ? [createChunk('title', request, {
      title: title
    })] : [];
  });
}